import React from 'react';
import PropTypes from 'prop-types';
import { useValidation } from '@glu/validation-react';

const RecurringFormProvider = ({ children, initialData, initialErrors }) => {
  const [FormContextProvider, formContext, { data: values }] = useValidation({
    initialData,
    ...(initialErrors ? { initialErrors } : [])
  });

  return (
    <FormContextProvider value={formContext}>
      {children({ values, formContext })}
    </FormContextProvider>
  );
};

RecurringFormProvider.propTypes = {
  children: PropTypes.func.isRequired,
  initialData: PropTypes.shape({}).isRequired,
  initialErrors: PropTypes.shape({})
};

RecurringFormProvider.defaultProps = {
  initialErrors: false
};

export default RecurringFormProvider;
